/**
 * Resolves after `ms` milliseconds.
 *
 * `window.setTimeout` rather than `requestAnimationFrame`: callers of this are
 * polling and backoff loops that must keep running while the tab is in the
 * background, and rAF callbacks are suspended entirely there.
 */
export function wait(ms: number): Promise<void> {
  return new Promise((resolve) => window.setTimeout(resolve, ms))
}
